<template>
  <div class="main-info">
    <a href="https://mst.su/education" target="_blank" class="main-info-request-training">Запросить обучение</a>

    <InfoList class="main-info-list" title="Демо проекты" :list="demoProjects" />
    <InfoList class="main-info-list" title="Документация" :list="documentation" />
    <InfoList class="main-info-list" title="Библиотека" :list="biblio" />

    <video-block :videos="videos" />
  </div>
</template>

<script>
import InfoList from "./InfoList.vue";
import VideoBlock from "./VideoBlock.vue";

export default {
  props: {
    showBiblio: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      demoProjects: [
        {
          text: "Проект расчета АЗС",
          target: "risk/254",
          type: "link",
        },
        {
          text: "Резервуарный парк",
          target: "risk/546",
          type: "link",
        },
        {
          text: "АЗС",
          target: "risk/541",
          type: "link",
        },
      ],
      documentation: [
        {
          text: "Как создать проект?",
          target: "instruction",
          type: "button",
        },
        {
          text: "Руководство пользователя.",
          target: "manual",
          type: "button",
        },
      ],
      biblio: [
        {
          text: "Баратов А.Н. и др. Пожаровзрывоопасность веществ и материалов и средства их тушения. Том 1. М. Химия, — 1990.",
          target: "biblioWindow",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/Baratov1.pdf",
        },
        {
          text: "Баратов А.Н. и др. Пожаровзрывоопасность веществ и материалов и средства их тушения. Том 2. М. Химия, — 1990.",
          target: "biblioWindow",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/Baratov2.pdf",
        },
        {
          text: "Федеральный закон от 21 июля 1997 г. N 116-ФЗ 'О промышленной безопасности опасных производственных объектов'",
          target: "biblioWindow",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/FZ116.pdf",
        },
        {
          text: "Федеральный закон от 22 июля 2008 г. N 123-ФЗ 'Технический регламент о требованиях пожарной безопасности'",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/FZ123.pdf",
        },
        {
          text: "Пособие по определению расчетных величин пожарного риска для производственных объектов. М.: ВНИИПО, 2012.",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/handbook.pdf",
        },
        {
          text: "Корольченко А.Я., Корольченко Д.А. Пожаровзрывоопасность веществ и материалов и средства их тушения. Справочник: в 2-х ч. Часть 1.",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/Korolchenko1.pdf",
        },
        {
          text: "Корольченко А.Я., Корольченко Д.А. Пожаровзрывоопасность веществ и материалов и средства их тушения. Справочник: в 2-х ч. Часть 2.",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/Korolchenko2.pdf",
        },
        {
          text: "Пособие по применению СП 12.13130.2009 'Определение категорий помещений, зданий и наружных установок по взрывопожарной и пожарной опасности' / И.М. Смолин и др. М.: ВНИИПО, 2014. 147 с.",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/Posobie_VNIIPO.pdf",
        },
        {
          text: "Пожарная безопасность. Энциклопедия. - М.: ФГУ ВНИИПО МЧС России, 2007. - 416 с.: ил.",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/Entsiklopedia.pdf",
        },
        {
          text: "Приказ МЧС РФ от 10 июля 2009 г. N 404 'Об утверждении методики определения расчетных величин пожарного риска на производственных объектах'",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/Prikaz404.pdf",
        },
        {
          text: "СНиП 2.01.01.-82. Строительная климатология и геофизика.",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/SNIP2010182.pdf",
        },
        {
          text: "СП 131.13330.2012. Актуализированная редакция СНиП 23-01-99*. Строительная климатология.",
          type: "button",
          callback: this.showBiblio,
          collbackTarget: "/biblio/SP131133302012.pdf",
        },
      ],
      videos: [
        {
          title: "Программа FireRisks",
          src: "https://www.youtube.com/embed/rrnrdgVW3M0",
        },
        {
          title: "Интерфейс программы",
          src: "https://www.youtube.com/embed/JNWg-Ci0Ysw",
        },
        {
          title: "Создание и расчет проекта",
          src: "https://www.youtube.com/embed/fppvIv5aLK8",
        },
        {
          title: "Расчет риска на АЗС за 5 минут",
          src: "https://www.youtube.com/embed/jVHWTaMSopM",
        },
      ],
    };
  },
  components: {
    InfoList,
    VideoBlock,
  },
};
</script>

<style scoped>
.main-info {
  position: relative;
  height: 100%;
  overflow: auto;
  padding: 16px 4px 0;
}

@media screen and (max-width: 900px) {
  .main-info {
    margin-top: 64px;
    height: auto;
  }
}
.main-info-list {
  margin-bottom: 24px;
}
.main-info-request-training {
  position: absolute;
  top: 16px;
  right: 8px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--primary-color);
  padding: 10px 24px;
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  transition: color 0.15s ease-out, border 0.15s ease-out;
}
.main-info-request-training:hover {
  border: 1px solid var(--primary-hover-color);
  color: 1px solid var(--primary-hover-color);
}
.main-info-list:last-child {
  margin-bottom: 0;
}
</style>
